export default "__VITE_ASSET__2ce730c5__"